import { colors } from "./tokens";
/**

The constants in this file should not be exported or used outside this library.
The values here are meant for aligning across components internally.

 */

export var ButtonStyles = {
  transitionBehaviour: "150ms ease-out",
  fastTransitionBehaviour: "100ms ease-out",
  primary: {
    hover: "#2b70ac"
  },
  success: {
    hover: "#0b8c5d"
  },
  critical: {
    hover: "#c93c4a"
  }
}; // // Color variations not included in UI kit

export var ColorVariations = {
  darkBlue: "#2471b3",
  primaryBlueOpacity: "rgba(54, 140, 215, .07)",
  cardBorderGrayOpacity: "rgba(223, 226, 229, .6)"
};
export var CheckControlStates = {
  labelColor: colors.gray.inkHeadings,
  labelColorDisabled: colors.gray.inkSubdued,
  "default": {
    transition: "box-shadow 300ms ease-in-out, border-color 300ms ease-in-out, background-color 300ms ease-in-out",
    background: colors.white,
    border: "1px solid ".concat(colors.gray.buttonBorders)
  },
  defaultHover: {
    border: "1px solid ".concat(colors.blue.hero)
  },
  defaultFocus: {
    border: "2px solid ".concat(colors.blue.hero),
    boxShadow: "0 0px 0px 2px ".concat(colors.blue.focusOutline)
  },
  defaultDisabled: {
    background: colors.gray[70],
    border: "1px solid ".concat(colors.gray.cardBorder),
    cursor: "not-allowed",
    boxShadow: "none"
  },
  checked: {
    background: colors.blue.hero,
    border: "1px solid ".concat(colors.blue.hero),
    boxShadow: "none"
  },
  checkedHover: {
    background: colors.blue.active,
    borderColor: colors.blue.active
  },
  checkedFocus: {
    background: colors.blue.hero,
    borderColor: colors.blue.active,
    border: "2px solid ".concat(colors.blue.active),
    boxShadow: "0 0px 0px 2px ".concat(colors.blue.focusOutline)
  },
  checkedDisabled: {
    background: colors.gray[60],
    border: "1px solid ".concat(colors.gray[60]),
    boxShadow: "none",
    cursor: "not-allowed"
  }
};
export var zIndexLevels = {
  modalBackdrop: 101,
  modalContent: 102,
  popover: 102,
  selectMenu: 110,
  globalAlert: 999,
  pageLoaderBackdrop: 9998,
  pageLoaderContent: 9999
};